import { useCallback, memo } from "react"
import NotificationSound from "../../assets/sounds/notificationNewMessages/newMessage.mp3"

export enum SoundType {
  BLEEP = "Bleep"
}

const soundAudioMapping: {
  [key in SoundType]: { elementId: string; src: string }
} = {
  [SoundType.BLEEP]: {
    elementId: "notification-bleep-layer",
    src: NotificationSound
  }
}

const useSoundAlert = () => {
  const playSound = useCallback((soundType: SoundType) => {
    const notificationPlayer = document.getElementById(
      soundAudioMapping[soundType].elementId
    ) as HTMLAudioElement
    notificationPlayer.volume = 0.4
    notificationPlayer.play()
  }, [])

  return playSound
}

export const SoundAudioList = memo(() => {
  const soundArray = Object.values(soundAudioMapping)

  return (
    <>
      {soundArray.map(sound => (
        <audio key={`global-audio-${sound.elementId}`} id={sound.elementId} src={sound.src} defaultValue={0.1} />
      ))}
    </>
  )
})

export default useSoundAlert
